import { FirebaseDbProvider } from '../../providers/firebase-db/firebase-db';
import { Component } from '@angular/core';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html'
})
export class LanguageComponent {

  constructor(private _db: FirebaseDbProvider) {
  }

  async getLanguage(key: string) {
    const user = await this._db.retrieveUserData(key);
    return user['language'];
  }

}
